export default __webpack_public_path__ + "static/media/smartcontract.c5744cad.svg";